import { isConnellsReferral } from "../ReferrerQuote/utils/ReferrerQuoteUtils";

export const isEstateAgentReferral = (leadSource) =>
  leadSource === "estate_agent_referrals" ||
  leadSource === "springbok" ||
  leadSource === "balgores" ||
  isConnellsReferral(leadSource);

// The "How did you hear about Juno?" answer a referred lead's source already
// gives us, or null when the client should still be asked.
export const leadSourceReferrer = (leadSource) => {
  if (isEstateAgentReferral(leadSource)) {
    return "Estate agent";
  }
  if (leadSource === "mortgage_broker_referrals") {
    return "Mortgage broker";
  }
  return null;
};
